import React from 'react';
import './sciqusfooter.scss'


const SciqusFooter = () => {
	return (
		<footer className="footer">
			<div className="footerContent">
				<div className="footerLeft">
				</div>
				
				<div className="footerRight">
					<p>Contact us @: Gratnakarg@gmail.com</p>
				</div>
			</div>
			
			<div className="footerBottom">
				<p>© {new Date().getFullYear()} Powered by Daily Dwelling. All Rights Reserved.</p>
				{/* <p>Powered by Daily Dwelling</p> */}
			</div>
		</footer>
	);
};

export default SciqusFooter;